module.exports = __webpack_public_path__ + "media/shared/assets/fonts/InterDisplay/InterDisplay-ExtraLight-8aac419550652c70acce102a1405b9e6.woff2";